import React from 'react';
import PublicPageLayout from '../PublicPageLayout';
import TermsOfService from '../../../../../pages/post-auth/home/tos/tos.component';

const TosPage = ({ history }) => (
  <PublicPageLayout history={history}>
    <TermsOfService />
  </PublicPageLayout>
);

export default TosPage;

